/* ============================================================================
 * th-collection-card.js — behaviour for the TH-style collection card.
 *   1. Quick add-to-cart (reuses Minimog's cart drawer) via event delegation,
 *      so it also covers cards added by pagination / infinite scroll.
 *   2. GSAP 3D hover tilt (lift + subtle rotate), fine-pointer + reduced-motion
 *      gated. GSAP core is global (bh-header); we poll for it and no-op if it
 *      never arrives (CSS hover-lift is the fallback).
 * ========================================================================== */
(function () {
  if (window.__thcCard) return;
  window.__thcCard = true;

  /* ---- 1. Quick add-to-cart (delegated) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.m-thc-card__cart') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading')) return;

    var S = window.MinimogSettings || {};
    var T = window.MinimogTheme || {};
    var E = window.MinimogEvents;
    var addUrl = (S.routes && S.routes.cart_add_url) ? S.routes.cart_add_url : '/cart/add';

    // Let the cart drawer register the sections it needs re-rendered — the same
    // mechanism Minimog's own add-to-cart uses. Without this the drawer never
    // refreshes/opens, so the add looks like it did nothing.
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', 1);
    if (sectionsToBundle.length) {
      fd.append('sections', sectionsToBundle.join(','));
      fd.append('sections_url', window.location.pathname);
    }

    btn.classList.add('is-loading');
    fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (res && res.status) {
          if (T.Notification) {
            T.Notification.show({ target: document.body, method: 'appendChild', type: 'error', message: res.message || res.description, last: 3000, sticky: true });
          }
          return;
        }
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
        // Refresh the cart count + drawer contents, then open the drawer —
        // both via Minimog's pub/sub events (canonical), with a direct fallback.
        if (E && T.pubSubEvents) {
          if (T.pubSubEvents.cartUpdate) {
            E.emit(T.pubSubEvents.cartUpdate, { cart: res, productVariantId: id });
          }
          if (T.pubSubEvents.openCartDrawer) {
            E.emit(T.pubSubEvents.openCartDrawer);
          }
        }
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        }
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  });

  /* ---- 2. GSAP hover tilt ---- */
  function initTilt() {
    var gsap = window.gsap;
    if (!gsap) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    [].forEach.call(document.querySelectorAll('.m-thc-card[data-thc-card]'), function (card) {
      if (card._thcTilt) return;
      card._thcTilt = true;
      var inner = card.querySelector('.m-thc-card__inner');
      if (!inner) return;
      card.classList.add('tilt-on');
      gsap.set(inner, { transformPerspective: 900, transformOrigin: 'center' });
      var qX = gsap.quickTo(inner, 'rotationX', { duration: 0.5, ease: 'power3' });
      var qY = gsap.quickTo(inner, 'rotationY', { duration: 0.5, ease: 'power3' });
      var qLift = gsap.quickTo(inner, 'y', { duration: 0.5, ease: 'power3' });
      var qScale = gsap.quickTo(inner, 'scale', { duration: 0.5, ease: 'power3' });

      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        qY(px * 2.2);
        qX(-py * 2.2);
        qLift(-3);
        qScale(1.01);
      });
      card.addEventListener('pointerleave', function () { qX(0); qY(0); qLift(0); qScale(1); });
    });
  }

  function whenGsap(tries) {
    tries = tries == null ? 40 : tries;
    if (window.gsap) return initTilt();
    if (tries <= 0) return;
    requestAnimationFrame(function () { whenGsap(tries - 1); });
  }

  function boot() { whenGsap(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  // Re-init cards injected by infinite scroll / load-more.
  document.addEventListener('shopify:section:load', function () { requestAnimationFrame(initTilt); });
})();
